module.exports = __webpack_public_path__ + "static/index/img/baikal-901.6e510ef0.jpg";